import BaseEnumType from "../../common/base-enum-type";

const Ruleset = Object.freeze({
    DefaultTennis: new BaseEnumType("DefaultTennisRules", "Default Tennis")
});

export default Ruleset;
